import { Unidade } from '@/domain/models'
import { atom } from 'recoil'

export const unitsState = atom({
  key: 'unitsState',
  default: {
    units: [] as Unidade[],
    currentUnit: 0
  }
})
